/* ==========================================================================
   AVVO — kleine Bedienhilfen ausserhalb des Warenkorbs. Eingebunden über
   AVVO-ANPASSUNG 7 in layout/theme.liquid; Styles in avvo-custom.css §9l
   (USP-Leiste), §9n und §9t (Slider für Bestseller und Kundenstimmen,
   unten in initSliders), §9y (Inhaltsverzeichnis der Rechtstexte, initLegal)
   und die Sprunglinks (#…) am Ende dieser Datei.

   USP-Leiste am Telefon (Kundenentscheid 24.09.2026, Variante B):
   Die Chips lassen sich seitlich wischen, das sieht man auf den ersten
   Blick aber nicht. Deshalb
     1. blendet der rechte Rand aus (CSS-Maske), solange rechts noch etwas
        kommt — `data-avvo-end` am Ende der Reihe schaltet das ab, damit der
        letzte Chip nicht halb verblasst;
     2. stupst die Reihe einmal an: sobald sie ganz sichtbar ist, gleiten
        die Chips kurz nach links und zurück (Klasse `avvo-usp--nudge`).
        Nur einmal pro Besuch (sessionStorage), nur am Telefon, nicht bei
        „Bewegung reduzieren" in den Geräteeinstellungen, und nicht mehr,
        wenn die Reihe schon gewischt oder berührt wurde.
   ========================================================================== */
(function () {
  var phone = window.matchMedia('(max-width: 640px)');
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var NUDGED = 'avvo-usp-nudged';

  function markEnd(row) {
    var atEnd = row.scrollLeft >= row.scrollWidth - row.clientWidth - 1;
    if (atEnd !== row.hasAttribute('data-avvo-end')) row.toggleAttribute('data-avvo-end', atEnd);
  }

  function alreadyNudged() {
    try { return !!sessionStorage.getItem(NUDGED); } catch (e) { return false; }
  }

  function nudgeOnce(row) {
    if (!phone.matches || reduceMotion.matches || alreadyNudged() || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      if (!entries[0].isIntersecting) return;
      io.disconnect();
      if (row.scrollLeft > 1 || row.hasAttribute('data-avvo-touched')) return;
      try { sessionStorage.setItem(NUDGED, '1'); } catch (e) {}
      row.classList.add('avvo-usp--nudge');
      /* animationend bubbelt von jedem Chip hoch — der erste reicht, alle
         laufen gleichzeitig */
      row.addEventListener('animationend', function () {
        row.classList.remove('avvo-usp--nudge');
      }, { once: true });
    }, { threshold: 0.9 });
    io.observe(row);
  }

  function init() {
    var row = document.querySelector('[id$="__usp"] .text-with-icons');
    if (!row) return;
    markEnd(row);
    row.addEventListener('scroll', function () { markEnd(row); }, { passive: true });
    window.addEventListener('resize', function () { markEnd(row); });
    /* Wer selbst wischt, braucht keinen Hinweis mehr — auch nicht mitten drin */
    row.addEventListener('touchstart', function () {
      row.setAttribute('data-avvo-touched', '');
      row.classList.remove('avvo-usp--nudge');
    }, { passive: true });
    nudgeOnce(row);
  }

  /* Slider (Sektionen mit data-avvo-slider: Bestseller, Kundenstimmen):
     Pfeile blättern um so viele Karten, wie sichtbar sind; am Anfang/Ende
     deaktiviert; passt alles hinein, verschwinden sie (avvo-slider--static).
     Wischen und Einrasten macht der Browser selbst (scroll-snap). */
  function initSliders(root) {
    (root || document).querySelectorAll('[data-avvo-slider]').forEach(function (section) {
      var track = section.querySelector('[data-avvo-track]');
      if (!track || track.hasAttribute('data-avvo-ready')) return;
      track.setAttribute('data-avvo-ready', '');
      var prev = section.querySelector('[data-avvo-slide="prev"]');
      var next = section.querySelector('[data-avvo-slide="next"]');

      function step() {
        var slide = track.firstElementChild;
        if (!slide) return track.clientWidth;
        var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        var per = Math.max(1, Math.round((track.clientWidth + gap) / (slide.offsetWidth + gap)));
        return per * (slide.offsetWidth + gap);
      }
      function update() {
        var max = track.scrollWidth - track.clientWidth;
        if (prev) prev.disabled = track.scrollLeft <= 1;
        if (next) next.disabled = track.scrollLeft >= max - 1;
        section.classList.toggle('avvo-slider--static', max <= 1);
      }
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  }

  /* Rechtstexte (sections/avvo-seite.liquid, Block „Rechtstext", 25.09.2026):
     Shopifys Richtlinien haben kaum echte Überschriften — AGB und
     Datenschutz setzen nummerierte Zeilen fett („1. Geltungsbereich"), das
     Impressum Beschriftungen („Zweck"). Zeilen, die nur aus fettem Text
     bestehen, werden zu Zwischentiteln (Klasse), nummerierte und echte
     Überschriften zusätzlich zu Einträgen im Inhaltsverzeichnis. Die Links
     tragen data-offset: Warehouses theme.js steuert jeden #-Link selbst an
     (offsetTop − data-offset) und kennt scroll-margin nicht; 160 = fixierter
     Kopf 143px + Luft. Ab 1000px ist das Verzeichnis eine feste Seitenleiste
     (immer offen), darunter ein aufklappbarer Kasten. */
  /* Die Richtlinien stammen aus einem alten Seitenbaukasten: Absätze beginnen
     und enden mit <br>, Titel stehen als „<strong>Titel</strong><br><br>Text"
     im selben Absatz. Nur die Darstellung wird aufgeräumt, kein Wort geändert:
     Umbrüche am Anfang/Ende eines Absatzes weg, solche Titel als eigene
     fette Zeile davor (wird unten zum Zwischentitel). */
  function isBlank(n) { return n.nodeType === 3 && !n.textContent.trim(); }
  function stripEdge(el, fromEnd) {
    var n = fromEnd ? el.lastChild : el.firstChild;
    while (n) {
      var next = fromEnd ? n.previousSibling : n.nextSibling;
      if (isBlank(n)) { n = next; continue; }
      if (n.nodeName === 'BR') { el.removeChild(n); n = next; continue; }
      if (n.nodeType === 1 && /^(SPAN|STRONG|B|EM|I)$/.test(n.nodeName)) stripEdge(n, fromEnd);
      break;
    }
  }
  function tidyLegal(body) {
    body.querySelectorAll('p').forEach(function (p) {
      var first = p.firstElementChild, n = p.firstChild;
      while (n && n !== first) { if (!isBlank(n)) { first = null; break; } n = n.nextSibling; }
      if (first && /^(STRONG|B)$/.test(first.nodeName)) {
        var after = first.nextSibling;
        while (after && isBlank(after)) after = after.nextSibling;
        var title = first.textContent.replace(/\s+/g, ' ').trim();
        if (after && after.nodeName === 'BR' && title && title.length <= 60 && !/:$/.test(title)) {
          var head = document.createElement('p'), s = document.createElement('strong');
          s.textContent = title;
          head.appendChild(s);
          p.parentNode.insertBefore(head, p);
          p.removeChild(first);
        }
      }
      stripEdge(p, false);
      stripEdge(p, true);
      if (!p.textContent.trim() && !p.querySelector('img')) p.remove();
    });
  }

  function initLegal(root) {
    var wide = window.matchMedia('(min-width: 1000px)');
    /* Shopifys eigene Richtlinienseiten (/policies/…, vom Checkout verlinkt):
       gleiche Aufräumung und Zwischentitel, ohne Inhaltsverzeichnis */
    (root || document).querySelectorAll('.shopify-policy__container').forEach(function (c) {
      var b = c.querySelector('.shopify-policy__body');
      if (!b) return;
      c.setAttribute('data-avvo-legal', '');
      b.setAttribute('data-avvo-legal-body', '');
    });
    (root || document).querySelectorAll('[data-avvo-legal]').forEach(function (block) {
      var body = block.querySelector('[data-avvo-legal-body]');
      if (!body || body.hasAttribute('data-avvo-legal-done')) return;
      body.setAttribute('data-avvo-legal-done', '');
      tidyLegal(body);
      var items = [], seenText = false;
      body.querySelectorAll('h2, h3, h4, p').forEach(function (el) {
        var text = el.textContent.replace(/\s+/g, ' ').trim();
        if (!text) return;
        if (/^H[2-4]$/.test(el.tagName)) {
          el.classList.add('avvo-pg__legal-h', 'avvo-pg__legal-h--main');
          if (!seenText) el.classList.add('avvo-pg__legal-h--first');
          seenText = true;
          items.push({ el: el, text: text });
          return;
        }
        var kids = Array.prototype.filter.call(el.childNodes, function (n) {
          return !(n.nodeType === 3 && !n.textContent.trim()) && n.nodeName !== 'BR';
        });
        if (/^[-–•]\s/.test(text)) { el.classList.add('avvo-pg__legal-li'); seenText = true; return; }
        if (kids.length !== 1 || !/^(STRONG|B)$/.test(kids[0].nodeName) || text.length > 90) { seenText = true; return; }
        el.classList.add('avvo-pg__legal-h');
        if (!seenText) el.classList.add('avvo-pg__legal-h--first');
        seenText = true;
        if (/^\d+\.\s/.test(text)) {
          el.classList.add('avvo-pg__legal-h--main');
          items.push({ el: el, text: text });
        }
      });
      var toc = block.querySelector('[data-avvo-toc]');
      if (!toc || items.length < 3) return;
      var list = toc.querySelector('ol');
      items.forEach(function (it, i) {
        if (!it.el.id) it.el.id = 'abschnitt-' + (i + 1);
        var li = document.createElement('li');
        var a = document.createElement('a');
        a.href = '#' + it.el.id;
        a.setAttribute('data-offset', '160');
        a.textContent = it.text;
        li.appendChild(a);
        list.appendChild(li);
      });
      toc.hidden = false;
      function sync() { toc.open = wide.matches; }
      sync();
      if (wide.addEventListener) wide.addEventListener('change', sync);
      toc.querySelector('summary').addEventListener('click', function (e) {
        if (wide.matches) e.preventDefault();        /* Seitenleiste bleibt offen */
      });
    });
  }

  function initAll() {
    init();
    initSliders();
    initLegal();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  /* Theme-Editor: Sektionen werden neu gezeichnet */
  document.addEventListener('shopify:section:load', function (e) { initSliders(e.target); initLegal(e.target); });
})();

/* --------------------------------------------------------------------------
   Sprunglinks (#…) unter dem klebenden Kopf (29.09.2026, Kunde: Sterne und
   „Benachrichtigen“ „scroll down too much“). Warehouse fängt in theme.js
   jeden Klick auf [href^="#"] ab und scrollt auf Oberkante − data-offset
   des Links (ohne Attribut: 0) — CSS scroll-margin-top übergeht es, das
   Ziel landete unter dem 134–143px hohen Kopf. Hier, vor Warehouse (Capture-
   Phase): Hat das Ziel scroll-margin-top und der Link kein eigenes
   data-offset (wie die FAQ-Chips mit 160), wird der Wert zur Klickzeit als
   data-offset gesetzt. So gilt ein Abstand für beide Wege: Sprung aus einer
   anderen Seite (Browser, scroll-margin) und Klick auf derselben Seite.
   -------------------------------------------------------------------------- */
(function () {
  document.addEventListener('click', function (e) {
    var link = e.target && e.target.closest ? e.target.closest('a[href^="#"]') : null;
    if (!link) return;
    if (link.hasAttribute('data-offset') && !link.hasAttribute('data-avvo-offset')) return;
    var selector = link.getAttribute('href');
    if (selector === '#' || selector === '#main') return;
    var target = null;
    try { target = document.querySelector(selector); } catch (err) { return; }
    if (!target) return;
    var margin = Math.round(parseFloat(window.getComputedStyle(target).scrollMarginTop) || 0);
    if (!margin) return;
    link.setAttribute('data-offset', margin);
    link.setAttribute('data-avvo-offset', '');
  }, true);
})();
